import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClassesList from "@/pages/ClassesList";
import Smartboard from "@/pages/Smartboard";
import Join from "@/pages/Join";
import StudentPlay from "@/pages/StudentPlay";
import TeacherInvite from "@/pages/TeacherInvite";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import DataRequest from "@/pages/DataRequest";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Join />} />
          <Route path="/teacher" element={<ClassesList />} />
          <Route path="/class/:id" element={<Smartboard />} />
          <Route path="/join" element={<Join />} />
          <Route path="/play/:code" element={<StudentPlay />} />
          <Route path="/teacher-invite/:token" element={<TeacherInvite />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/data-request" element={<DataRequest />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
